// Kulki: the version the player picked in the Games window (owner 2026-11-03: 5 in a row or the easier 4, a drop-down
// list like 3-5-8's length, 5 by default). Kept in the browser (a long game's New game reloads the page).
import { LINE, LINES } from '../kulki/rules';

const KEY = 'solitaire_storage:kulki-line';

export function pickedKulkiLine(): number {
  try {
    const n = Number(localStorage.getItem(KEY));
    return (LINES as readonly number[]).includes(n) ? n : LINE;
  } catch {
    return LINE;
  }
}

export function pickKulkiLine(n: number): void {
  try {
    localStorage.setItem(KEY, String(n));
  } catch {
    // no storage (a private window): the pick lasts until the page reloads
  }
}
